module.exports = __webpack_public_path__ + "img/slider_2.4ecf0f0b.jpg";